import { useUI } from "providers/UIProvider"

import { Box, Flex } from "@chakra-ui/react"

import MainLayout from "../MainLayout"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import CompanyBranches from "components/shared/CompanyBranches"
import EmployeesTable from "./EmployeesTable"
import { useAppContext } from "providers/AppProvider/AppProvider"

const EmployeesTamplate = () => {
  const { toggleModal, T } = useUI()
  const { selectedBranches } = useAppContext()

  return (
    
    <MainLayout navigation>
      <Flex flexDirection={"column"} >
        <Flex
          width={"100%"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <CompanyBranches />
          <Button
            disabled={selectedBranches.length > 1}
            leftIcon={
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                height={"34px"}
                width={"34px"}
                borderRadius={"xl"}
                background={"primary"}
              >
                <Icon
                  iconStyles={{ height: "17px", width: "17px" }}
                  name='add_person'
                />
              </Box>
            }
            styles={{
              width: "180px",
              height: "63px",
              fontSize: "xl",
              lineHeight: "28px",
            }}
            onClick={() => toggleModal("addEditEmployeeModal", true)}
            text={T("employees.add")}
            variant='solid_white'
          />
        </Flex>
        <Box mt={"20px"}>
          <EmployeesTable />
        </Box>
      </Flex>
    </MainLayout>
  )
}
export default EmployeesTamplate

